import script from "./PortfolioDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioDetail.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioDetail.vue?vue&type=style&index=0&id=45a712dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a712dc"]])

export default __exports__